import { useState, useEffect, useCallback } from 'react';
import { useDubs } from '../provider';
import type { QueryResult } from '../types';

export interface ShortVideo {
  videoId: string;
  title: string;
  channelTitle: string;
  thumbnail: string;
  publishedAt: string;
}

export function useShorts(league: string = 'NBA', limit: number = 20): QueryResult<ShortVideo[]> {
  const { client } = useDubs();
  const [data, setData] = useState<ShortVideo[] | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const qs = new URLSearchParams({ league, limit: String(limit) });
      const res = await (client as any).request('GET', `/shorts?${qs.toString()}`);
      setData(res.videos || []);
    } catch (err) {
      setError(err instanceof Error ? err : new Error(String(err)));
    } finally {
      setLoading(false);
    }
  }, [client, league, limit]);

  useEffect(() => { fetchData(); }, [fetchData]);

  return { data, loading, error, refetch: fetchData };
}
